angular.module('edxResources')
  .controller('EdxResourcesController', [
    '$rootScope',
    '$scope',
    '$timeout',
    '$window',
    'customerApi',
    'configuration',
    'edxResourcesContentService',
    'authentication',
    function ($rootScope,
              $scope,
              $timeout,
              $window,
              customerApi,
              configuration,
              edxResourcesContentService) {
      var vm = this;

      $scope.module = "module1";

      var homeUrl = configuration.getConstant('dreambox_home_url');
      $scope.isDemoEnvironment = configuration.isFeatureEnabled('demo_lessons');
      var initializeData = function () {
        customerApi.getCustomer().$promise.then(function(customer) {
          var resourcesContent = edxResourcesContentService.getResources(customer.role);
          vm.customerRole = customer.role;

          vm.startHereModules = resourcesContent.startHereModules;
          vm.classroomTabData = resourcesContent.classroomTabData;
          vm.parentsTabData = resourcesContent.parentsTabData;
          vm.dashboardTabData = resourcesContent.dashboardTabData;
          vm.motivatorsTabData = resourcesContent.motivatorsTabData;
        });
      };

      var customer = customerApi.getCustomer();

      var isImpersonating = (customer && customer.impersonated_admin_id);
      var dreamboxNationLink = isImpersonating ? '' : configuration.getConstant('advocate_hub_fqdn');

      vm.moreResourcesLinks = [
        {label: 'DreamBox Teacher Tools', url: homeUrl + '/teachertools', isExternal: true},
        {label: 'DreamBox Nation', url: dreamboxNationLink, isExternal: true},
        {label: 'DreamBox Support', url: 'http://support.dreambox.com/', isExternal: true},
        {label: 'DreamBox Blog', url: homeUrl + '/blog/', isExternal: true}
      ];

      vm.demoLessonsData = [
        {
          label: 'Grades K-2 Environment Lesson',
          imageUrl: '/resources/images/thumbnails/Demo-LessonVisualMath.png',
          lessonName: 'BuildVisualMathrack11to20',
          lessonFriendlyName: 'Build Visual Math Rack 11 to 20'

        },
        {
          label: 'Grades 3-5 Environment Lesson',
          imageUrl: '/resources/images/thumbnails/Demo-LessonComposingArrays.png',
          lessonName: 'Multiplication_BuildingArrays_Exploration_LevelOne',
          lessonFriendlyName: 'Composing Arrays to 600'
        },
        {
          label: 'Grades 6-8 Environment Lesson',
          imageUrl: '/resources/images/thumbnails/Demo-Lesson2DArray.png',
          lessonName: 'Polynomial_2D_Array_LevelEighteen',
          lessonFriendlyName: 'Polynomial 2D Array'
        },
      ];

      vm.onNavToggle = function () {
        $rootScope.$broadcast('onNavToggle');
        // reflow window on menu click so highcharts knows to update size
        $timeout(function () {
          $($window).resize();
        }, 400);
      };

      $scope.onModuleChange = function (moduleId) {
        $scope.module = "module" + moduleId;
      };

      initializeData();
    }
  ]);
